import React, { useEffect, useState } from 'react';
import apiClient from '../utils/apiClient';

const NotificationSettingsManager = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [settings, setSettings] = useState({
    dailyScheduleNotificationsEnabled: true,
    dailyAvailabilityRemindersEnabled: true,
  });
  const [initialSettings, setInitialSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await apiClient.get('/api/settings');
        setSettings({
          dailyScheduleNotificationsEnabled: !!response.data.dailyScheduleNotificationsEnabled,
          dailyAvailabilityRemindersEnabled: !!response.data.dailyAvailabilityRemindersEnabled,
        });
        setInitialSettings({
          dailyScheduleNotificationsEnabled: !!response.data.dailyScheduleNotificationsEnabled,
          dailyAvailabilityRemindersEnabled: !!response.data.dailyAvailabilityRemindersEnabled,
        });
      } catch (e) {
        setError('Failed to load notification settings');
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const hasChanges = initialSettings && (
    initialSettings.dailyScheduleNotificationsEnabled !== settings.dailyScheduleNotificationsEnabled ||
    initialSettings.dailyAvailabilityRemindersEnabled !== settings.dailyAvailabilityRemindersEnabled
  );

  const handleToggle = (key) => (e) => {
    setSettings(prev => ({ ...prev, [key]: e.target.checked }));
    setError('');
    setSuccess('');
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      await apiClient.put('/api/settings/notifications', {
        dailyScheduleNotificationsEnabled: settings.dailyScheduleNotificationsEnabled,
        dailyAvailabilityRemindersEnabled: settings.dailyAvailabilityRemindersEnabled,
      });
      setInitialSettings(settings);
      setSuccess('Notification settings updated');
    } catch (e) {
      const message = e.response?.data?.error || 'Failed to update notification settings';
      setError(message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading notification settings...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="card-header">
        <h2 className="card-title">Daily Notifications</h2>
        <p className="mb-2" style={{ color: '#6b7280', fontSize: '0.9em' }}>
          Toggle daily schedule and availability reminder notifications sent at 5:00 PM Eastern.
        </p>
      </div>

      {error && (
        <div className="alert alert-error" style={{ marginBottom: '12px' }}>{error}</div>
      )}
      {success && (
        <div className="alert alert-success" style={{ marginBottom: '12px' }}>{success}</div>
      )}

      <div className="form-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={settings.dailyScheduleNotificationsEnabled}
            onChange={handleToggle('dailyScheduleNotificationsEnabled')}
          />
          Enable daily schedule notifications
        </label>
        <div className="form-text text-muted" style={{ fontSize: '0.9em' }}>
          Sends notifications to users scheduled for tomorrow's shifts.
        </div>
      </div>

      <div className="form-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={settings.dailyAvailabilityRemindersEnabled}
            onChange={handleToggle('dailyAvailabilityRemindersEnabled')}
          />
          Enable daily availability reminders
        </label>
        <div className="form-text text-muted" style={{ fontSize: '0.9em' }}>
          Reminds users to mark availability for upcoming days.
        </div>
      </div>

      <div className="form-actions" style={{ marginTop: '12px' }}>
        <button
          onClick={handleSave}
          className="btn btn-primary"
          disabled={saving || !hasChanges}
        >
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
};

export default NotificationSettingsManager;


